import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "q-gutter-md",
  style: {"max-width":"500px"}
}
const _hoisted_2 = { class: "row items-start q-gutter-sm" }
const _hoisted_3 = {
  key: 0,
  class: "text-caption text-grey-6 text-center q-mt-xs"
}
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-grey-7 q-mt-xs"
}
const _hoisted_5 = { class: "cursor-pointer text-primary" }
const _hoisted_6 = { class: "cursor-pointer text-primary" }
const _hoisted_7 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_8 = {
  key: 1,
  class: "q-mt-xs"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "text-caption text-positive row items-center no-wrap"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "q-mt-md" }
const _hoisted_15 = {
  ref: "createMiniMap",
  style: {"height":"250px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_16 = {
  class: "q-gutter-md",
  style: {"max-width":"500px"}
}
const _hoisted_17 = { class: "row items-start q-gutter-sm" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "row items-center q-gutter-sm" }
const _hoisted_20 = { class: "text-body2" }
const _hoisted_21 = {
  key: 0,
  class: "text-caption text-grey-6 text-center q-mt-xs"
}
const _hoisted_22 = {
  key: 1,
  class: "text-caption text-grey-7 q-mt-xs"
}
const _hoisted_23 = { class: "cursor-pointer text-primary" }
const _hoisted_24 = { class: "cursor-pointer text-primary" }
const _hoisted_25 = { class: "q-mt-xs row items-center no-wrap" }
const _hoisted_26 = {
  key: 2,
  class: "q-mt-xs"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  class: "text-caption text-positive row items-center no-wrap"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "row q-gutter-sm" }
const _hoisted_33 = { class: "q-mt-md" }
const _hoisted_34 = {
  ref: "miniMap",
  style: {"height":"250px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_35 = { style: {"white-space":"pre-wrap","word-break":"break-all","font-size":"13px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_InstructionCard = _resolveComponent("InstructionCard")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"540px","max-width":"95vw"},
          class: "manage-ps-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, null, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode("Pipeline Manager", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
              dense: "",
              class: "text-grey",
              "active-color": "blue-brand",
              "indicator-color": "blue-brand",
              align: "left",
              "update-csv-file": "",
              "narrow-indicator": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab, {
                  name: "create",
                  label: "Create New"
                }),
                _createVNode(_component_q_tab, {
                  name: "update",
                  label: "Update Existing"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_tab_panels, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tab) = $event)),
              animated: "",
              "keep-alive": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab_panel, { name: "create" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.createName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createName) = $event)),
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Name e.g., Oklahoma City to Tulsa",
                        error: _ctx.createNameError !== '',
                        "error-message": _ctx.createNameError
                      }, null, 8, ["modelValue", "error", "error-message"]),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.createDiameter,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createDiameter) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: 
                  'Diameter (' +
                  (_ctx.createDiameterUnit === 'in' ? 'inches' : 'cm') +
                  ')'
                ,
                          error: _ctx.createDiameterError !== '',
                          "error-message": _ctx.createDiameterError,
                          rules: [_ctx.createDiameterRule],
                          "reactive-rules": "",
                          class: "col"
                        }, null, 8, ["modelValue", "label", "error", "error-message", "rules"]),
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.createDiameterUnit,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createDiameterUnit) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          options: [
                  { label: 'in', value: 'in' },
                  { label: 'cm', value: 'cm' },
                ],
                          "emit-value": "",
                          "map-options": "",
                          style: {"width":"90px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["csv-drop-zone", { 'csv-drop-zone--active': _ctx.createDragOver }]),
                        onDragover: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.createDragOver = true), ["prevent"])),
                        onDragenter: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.createDragOver = true), ["prevent"])),
                        onDragleave: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.createDragOver = false), ["prevent"])),
                        onDrop: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.onDropCsv($event, 'create')), ["prevent"]))
                      }, [
                        _createVNode(_component_q_file, {
                          modelValue: _ctx.createCsvFile,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createCsvFile) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: "Survey Markers and Tracking Locations (CSV) File Upload",
                          accept: ".csv",
                          clearable: "",
                          error: _ctx.createCsvFileError !== '',
                          "error-message": _ctx.createCsvFileError
                        }, _createSlots({
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "attach_file" })
                          ]),
                          _: 2
                        }, [
                          (_ctx.createCsvFile && _ctx.createCsvValidation)
                            ? {
                                name: "append",
                                fn: _withCtx(() => [
                                  (_ctx.createCsvValidation.errors.length > 0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 0,
                                        color: "negative",
                                        label: 
                      _ctx.createCsvValidation.errors.length +
                      ' error' +
                      (_ctx.createCsvValidation.errors.length > 1 ? 's' : '')
                    ,
                                        class: "q-mr-xs"
                                      }, null, 8, ["label"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.createCsvValidation.warnings.length > 0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 1,
                                        color: "amber-8",
                                        label: 
                      _ctx.createCsvValidation.warnings.length +
                      ' warning' +
                      (_ctx.createCsvValidation.warnings.length > 1 ? 's' : '')
                    
                                      }, null, 8, ["label"]))
                                    : _createCommentVNode("", true)
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["modelValue", "error", "error-message"]),
                        (!_ctx.createCsvFile)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " or drag & drop a CSV file here "))
                          : _createCommentVNode("", true)
                      ], 34),
                      (!_ctx.createCsvFile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_q_icon, {
                              name: "info",
                              size: "14px",
                              class: "q-mr-xs"
                            }),
                            _cache[34] || (_cache[34] = _createTextVNode(" Required columns: AGM Marker Name, Latitude, Longitude, ", -1)),
                            _createElementVNode("span", _hoisted_5, [
                              _cache[29] || (_cache[29] = _createTextVNode(" State ", -1)),
                              _createVNode(_component_q_tooltip, {
                                class: "text-body2",
                                anchor: "top middle",
                                self: "bottom middle",
                                "max-width": "220px"
                              }, {
                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                  _createTextVNode(" Valid values: TRACK, SKIP ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _cache[35] || (_cache[35] = _createTextVNode(", ", -1)),
                            _createElementVNode("span", _hoisted_6, [
                              _cache[31] || (_cache[31] = _createTextVNode(" Description ", -1)),
                              _createVNode(_component_q_tooltip, {
                                class: "text-body2",
                                anchor: "top middle",
                                self: "bottom middle",
                                "max-width": "280px"
                              }, {
                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                  _createTextVNode(" Valid values: AGM, ATTACHMENT, BEND, LAUNCH, MAGNET, OTHER, PIPE, RECEIVE, TAP, TEE, VALVE, WELD ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _cache[36] || (_cache[36] = _createTextVNode(". ", -1)),
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-primary",
                              style: {"text-decoration":"underline"},
                              onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownloadExampleCsv && _ctx.onDownloadExampleCsv(...args)), ["prevent"]))
                            }, "Download example CSV"),
                            _createElementVNode("div", _hoisted_7, [
                              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-grey-8" }, "Header (first line): ", -1)),
                              _cache[33] || (_cache[33] = _createElementVNode("code", {
                                class: "text-grey-9",
                                style: {"font-size":"11px"}
                              }, " AGM Marker Name,Latitude,Longitude,State,Description ", -1)),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                round: "",
                                dense: "",
                                size: "xs",
                                icon: "content_copy",
                                color: "grey-7",
                                title: "Copy header to clipboard",
                                class: "q-ml-xs",
                                onClick: _ctx.onCopyHeader
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.createCsvFile && _ctx.createCsvValidation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_ctx.createCsvValidation.errors.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showAllCreateErrors
                    ? _ctx.createCsvValidation.errors
                    : _ctx.createCsvValidation.errors.slice(0, 3), (err, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'ce-' + idx,
                                      class: "text-caption text-negative row items-start no-wrap q-mb-xs",
                                      style: _normalizeStyle(_ctx.hasRowRef(err) ? { cursor: 'pointer' } : {}),
                                      onClick: ($event: any) => (_ctx.scrollToErrorRow('createPreviewTable', err))
                                    }, [
                                      _createVNode(_component_q_icon, {
                                        name: "error",
                                        size: "16px",
                                        class: "q-mr-xs",
                                        color: "negative",
                                        style: {"flex-shrink":"0","margin-top":"1px"}
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(err), 1)
                                    ], 12, _hoisted_10))
                                  }), 128)),
                                  (
                    _ctx.createCsvValidation.errors.length > 3 &&
                    !_ctx.showAllCreateErrors
                  )
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: "#",
                                        class: "text-caption text-primary",
                                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showAllCreateErrors = true), ["prevent"]))
                                      }, " Show " + _toDisplayString(_ctx.createCsvValidation.errors.length - 3) + " more error(s) ", 1))
                                    : _createCommentVNode("", true),
                                  (
                    _ctx.createCsvValidation.errors.length > 3 && _ctx.showAllCreateErrors
                  )
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: "#",
                                        class: "text-caption text-primary",
                                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showAllCreateErrors = false), ["prevent"]))
                                      }, " Show fewer errors "))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.createCsvValidation.warnings.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createCsvValidation.warnings, (warn, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'cw-' + idx,
                                      class: "text-caption text-amber-9 row items-start no-wrap q-mb-xs"
                                    }, [
                                      _createVNode(_component_q_icon, {
                                        name: "warning",
                                        size: "16px",
                                        class: "q-mr-xs",
                                        color: "amber-8",
                                        style: {"flex-shrink":"0","margin-top":"1px"}
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(warn), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.createCsvValidation.valid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_q_icon, {
                                    name: "check_circle",
                                    size: "16px",
                                    class: "q-mr-xs",
                                    color: "positive"
                                  }),
                                  _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString(_ctx.createCsvValidation.parsedRows.length) + " data rows, " + _toDisplayString(_ctx.createCsvValidation.markerCount) + " markers parsed — " + _toDisplayString(_ctx.createCsvValidation.firstMarker) + " → " + _toDisplayString(_ctx.createCsvValidation.lastMarker), 1),
                                    (_ctx.createCsvValidation.skipCount > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " · " + _toDisplayString(_ctx.createCsvValidation.skipCount) + " SKIP", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (
                _ctx.createCsvFile &&
                _ctx.createCsvValidation &&
                _ctx.createCsvValidation.parsedRows.length > 0
              )
                        ? (_openBlock(), _createBlock(_component_q_table, {
                            key: 2,
                            ref: "createPreviewTable",
                            rows: _ctx.createCsvValidation.parsedRows,
                            columns: _ctx.csvPreviewColumns,
                            "row-key": "row",
                            flat: "",
                            bordered: "",
                            dense: "",
                            "hide-bottom": "",
                            "rows-per-page-options": [0],
                            class: "q-mt-sm csv-preview-table",
                            style: { maxHeight: '200px', overflowY: 'auto' }
                          }, {
                            body: _withCtx((props) => [
                              _createVNode(_component_q_tr, {
                                props: props,
                                "data-row": props.row.row
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                    return (_openBlock(), _createBlock(_component_q_td, {
                                      key: col.name,
                                      props: props,
                                      class: _normalizeClass({
                      'bg-red-1': props.row.errorFields.includes(col.name),
                    })
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(col.value), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["props", "class"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["props", "data-row"])
                            ]),
                            _: 1
                          }, 8, ["rows", "columns"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Create",
                          loading: _ctx.loading,
                          disable: 
                  !!(
                    _ctx.createCsvFile &&
                    (!_ctx.createCsvValidation || !_ctx.createCsvValidation.valid)
                  )
                ,
                          onClick: _ctx.onCreateSubmit
                        }, null, 8, ["loading", "disable", "onClick"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_14, [
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Pipeline Preview ", -1)),
                        _createElementVNode("div", _hoisted_15, null, 512)
                      ], 512), [
                        [_vShow, _ctx.createCsvFile]
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, { name: "update" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.selectedPipelineSection,
                        "onUpdate:modelValue": [
                          _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedPipelineSection) = $event)),
                          _ctx.onPipelineSectionSelected
                        ],
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Name",
                        options: _ctx.pipelineSectionOptions,
                        loading: _ctx.loading,
                        clearable: "",
                        onClear: _ctx.onPipelineSectionCleared
                      }, null, 8, ["modelValue", "options", "loading", "onUpdate:modelValue", "onClear"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.updateDiameter,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.updateDiameter) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: 
                  'Diameter (' +
                  (_ctx.updateDiameterUnit === 'in' ? 'inches' : 'cm') +
                  ')'
                ,
                          disable: !_ctx.selectedPipelineSection,
                          rules: [(val) => !!val || 'Diameter is required.'],
                          class: "col"
                        }, null, 8, ["modelValue", "label", "disable", "rules"]),
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.updateDiameterUnit,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.updateDiameterUnit) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          options: [
                  { label: 'in', value: 'in' },
                  { label: 'cm', value: 'cm' },
                ],
                          "emit-value": "",
                          "map-options": "",
                          disable: !_ctx.selectedPipelineSection,
                          style: {"width":"90px"}
                        }, null, 8, ["modelValue", "disable"])
                      ]),
                      (_ctx.selectedPipelineSection && _ctx.currentTrackingFileName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Current Tracking File ", -1)),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.currentTrackingFileName), 1),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                dense: "",
                                size: "sm",
                                icon: "visibility",
                                color: "blue-brand",
                                title: "View file",
                                onClick: _ctx.onViewTrackingFile
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                dense: "",
                                size: "sm",
                                icon: "download",
                                color: "blue-brand",
                                title: "Download file",
                                onClick: _ctx.onDownloadTrackingFile
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["csv-drop-zone", {
                'csv-drop-zone--active':
                  _ctx.updateDragOver && _ctx.selectedPipelineSection,
              }]),
                        onDragover: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.updateDragOver = true), ["prevent"])),
                        onDragenter: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.updateDragOver = true), ["prevent"])),
                        onDragleave: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.updateDragOver = false), ["prevent"])),
                        onDrop: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.onDropCsv($event, 'update')), ["prevent"]))
                      }, [
                        _createVNode(_component_q_file, {
                          modelValue: _ctx.updateCsvFile,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.updateCsvFile) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: "Survey Markers and Tracking Locations (CSV) File Upload",
                          accept: ".csv",
                          clearable: "",
                          disable: !_ctx.selectedPipelineSection
                        }, _createSlots({
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "attach_file" })
                          ]),
                          _: 2
                        }, [
                          (_ctx.updateCsvFile && _ctx.updateCsvValidation)
                            ? {
                                name: "append",
                                fn: _withCtx(() => [
                                  (_ctx.updateCsvValidation.errors.length > 0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 0,
                                        color: "negative",
                                        label: 
                      _ctx.updateCsvValidation.errors.length +
                      ' error' +
                      (_ctx.updateCsvValidation.errors.length > 1 ? 's' : '')
                    ,
                                        class: "q-mr-xs"
                                      }, null, 8, ["label"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.updateCsvValidation.warnings.length > 0)
                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                        key: 1,
                                        color: "amber-8",
                                        label: 
                      _ctx.updateCsvValidation.warnings.length +
                      ' warning' +
                      (_ctx.updateCsvValidation.warnings.length > 1 ? 's' : '')
                    
                                      }, null, 8, ["label"]))
                                    : _createCommentVNode("", true)
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["modelValue", "disable"]),
                        (!_ctx.updateCsvFile && _ctx.selectedPipelineSection)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, " or drag & drop a CSV file here "))
                          : _createCommentVNode("", true)
                      ], 34),
                      (!_ctx.updateCsvFile && _ctx.selectedPipelineSection)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_q_icon, {
                              name: "info",
                              size: "14px",
                              class: "q-mr-xs"
                            }),
                            _cache[45] || (_cache[45] = _createTextVNode(" Required columns: AGM Marker Name, Latitude, Longitude, ", -1)),
                            _createElementVNode("span", _hoisted_23, [
                              _cache[40] || (_cache[40] = _createTextVNode(" State ", -1)),
                              _createVNode(_component_q_tooltip, {
                                class: "text-body2",
                                anchor: "top middle",
                                self: "bottom middle",
                                "max-width": "220px"
                              }, {
                                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                  _createTextVNode(" Valid values: TRACK, SKIP ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _cache[46] || (_cache[46] = _createTextVNode(", ", -1)),
                            _createElementVNode("span", _hoisted_24, [
                              _cache[42] || (_cache[42] = _createTextVNode(" Description ", -1)),
                              _createVNode(_component_q_tooltip, {
                                class: "text-body2",
                                anchor: "top middle",
                                self: "bottom middle",
                                "max-width": "280px"
                              }, {
                                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                  _createTextVNode(" Valid values: AGM, ATTACHMENT, BEND, LAUNCH, MAGNET, OTHER, PIPE, RECEIVE, TAP, TEE, VALVE, WELD ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _cache[47] || (_cache[47] = _createTextVNode(". ", -1)),
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-primary",
                              style: {"text-decoration":"underline"},
                              onClick: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDownloadExampleCsv && _ctx.onDownloadExampleCsv(...args)), ["prevent"]))
                            }, "Download example CSV"),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-grey-8" }, "Header (first line): ", -1)),
                              _cache[44] || (_cache[44] = _createElementVNode("code", {
                                class: "text-grey-9",
                                style: {"font-size":"11px"}
                              }, " AGM Marker Name,Latitude,Longitude,State,Description ", -1)),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                round: "",
                                dense: "",
                                size: "xs",
                                icon: "content_copy",
                                color: "grey-7",
                                title: "Copy header to clipboard",
                                class: "q-ml-xs",
                                onClick: _ctx.onCopyHeader
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.updateCsvFile && _ctx.updateCsvValidation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_ctx.updateCsvValidation.errors.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showAllUpdateErrors
                    ? _ctx.updateCsvValidation.errors
                    : _ctx.updateCsvValidation.errors.slice(0, 3), (err, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'ue-' + idx,
                                      class: "text-caption text-negative row items-start no-wrap q-mb-xs",
                                      style: _normalizeStyle(_ctx.hasRowRef(err) ? { cursor: 'pointer' } : {}),
                                      onClick: ($event: any) => (_ctx.scrollToErrorRow('updatePreviewTable', err))
                                    }, [
                                      _createVNode(_component_q_icon, {
                                        name: "error",
                                        size: "16px",
                                        class: "q-mr-xs",
                                        color: "negative",
                                        style: {"flex-shrink":"0","margin-top":"1px"}
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(err), 1)
                                    ], 12, _hoisted_28))
                                  }), 128)),
                                  (
                    _ctx.updateCsvValidation.errors.length > 3 &&
                    !_ctx.showAllUpdateErrors
                  )
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: "#",
                                        class: "text-caption text-primary",
                                        onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.showAllUpdateErrors = true), ["prevent"]))
                                      }, " Show " + _toDisplayString(_ctx.updateCsvValidation.errors.length - 3) + " more error(s) ", 1))
                                    : _createCommentVNode("", true),
                                  (
                    _ctx.updateCsvValidation.errors.length > 3 && _ctx.showAllUpdateErrors
                  )
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: "#",
                                        class: "text-caption text-primary",
                                        onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.showAllUpdateErrors = false), ["prevent"]))
                                      }, " Show fewer errors "))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.updateCsvValidation.warnings.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateCsvValidation.warnings, (warn, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'uw-' + idx,
                                      class: "text-caption text-amber-9 row items-start no-wrap q-mb-xs"
                                    }, [
                                      _createVNode(_component_q_icon, {
                                        name: "warning",
                                        size: "16px",
                                        class: "q-mr-xs",
                                        color: "amber-8",
                                        style: {"flex-shrink":"0","margin-top":"1px"}
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(warn), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.updateCsvValidation.valid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_component_q_icon, {
                                    name: "check_circle",
                                    size: "16px",
                                    class: "q-mr-xs",
                                    color: "positive"
                                  }),
                                  _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString(_ctx.updateCsvValidation.parsedRows.length) + " data rows, " + _toDisplayString(_ctx.updateCsvValidation.markerCount) + " markers parsed — " + _toDisplayString(_ctx.updateCsvValidation.firstMarker) + " → " + _toDisplayString(_ctx.updateCsvValidation.lastMarker), 1),
                                    (_ctx.updateCsvValidation.skipCount > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, " · " + _toDisplayString(_ctx.updateCsvValidation.skipCount) + " SKIP", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (
                _ctx.updateCsvFile &&
                _ctx.updateCsvValidation &&
                _ctx.updateCsvValidation.parsedRows.length > 0
              )
                        ? (_openBlock(), _createBlock(_component_q_table, {
                            key: 3,
                            ref: "updatePreviewTable",
                            rows: _ctx.updateCsvValidation.parsedRows,
                            columns: _ctx.csvPreviewColumns,
                            "row-key": "row",
                            flat: "",
                            bordered: "",
                            dense: "",
                            "hide-bottom": "",
                            "rows-per-page-options": [0],
                            class: "q-mt-sm csv-preview-table",
                            style: { maxHeight: '200px', overflowY: 'auto' }
                          }, {
                            body: _withCtx((props) => [
                              _createVNode(_component_q_tr, {
                                props: props,
                                "data-row": props.row.row
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                    return (_openBlock(), _createBlock(_component_q_td, {
                                      key: col.name,
                                      props: props,
                                      class: _normalizeClass({
                      'bg-red-1': props.row.errorFields.includes(col.name),
                    })
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(col.value), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["props", "class"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["props", "data-row"])
                            ]),
                            _: 1
                          }, 8, ["rows", "columns"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Update",
                          disable: 
                  !_ctx.selectedPipelineSection ||
                  !!(
                    _ctx.updateCsvFile &&
                    (!_ctx.updateCsvValidation || !_ctx.updateCsvValidation.valid)
                  )
                ,
                          loading: _ctx.loading,
                          onClick: _ctx.onUpdateSubmit
                        }, null, 8, ["disable", "loading", "onClick"]),
                        _createVNode(_component_q_btn, {
                          color: "negative",
                          label: "Delete",
                          disable: !_ctx.selectedPipelineSection,
                          loading: _ctx.loading,
                          onClick: _ctx.onDeleteSubmit
                        }, null, 8, ["disable", "loading", "onClick"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_33, [
                        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Pipeline Preview ", -1)),
                        _createElementVNode("div", _hoisted_34, null, 512)
                      ], 512), [
                        [_vShow, _ctx.selectedPipelineSection && _ctx.currentTrackingFile]
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_dialog, {
          modelValue: _ctx.viewTrackingFileDialog,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.viewTrackingFileDialog) = $event)),
          maximized: "",
          onHide: _ctx.onViewTrackingFileDialogHide
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_toolbar_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentTrackingFileName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "download",
                      title: "Download",
                      onClick: _ctx.onDownloadTrackingFile
                    }, null, 8, ["onClick"]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "close"
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, {
                  class: "q-pa-md",
                  style: {"overflow":"auto","max-height":"calc(100vh - 50px)"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("pre", _hoisted_35, _toDisplayString(_ctx.currentTrackingFile), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onHide"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_InstructionCard, {
      modelValue: _ctx.showInstructions,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.showInstructions) = $event)),
      title: "Pipelines",
      icon: "description",
      message: "Create a pipeline by entering a name, diameter, and uploading a CSV file with your marker positions.",
      tip: "Download an example CSV to see the expected format.",
      "tip-action-label": "Download example CSV",
      "z-index": 7000,
      onTipAction: _ctx.onDownloadExampleCsv
    }, null, 8, ["modelValue", "onTipAction"])
  ], 64))
}